import Model from "../Model";

class ZonesByGestnoGest extends Model{

    buildUrl ({ param }) {
        return ['industrialgroupview/getzonesbydivisionid', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new ZonesByGestnoGest;